import firebase from "firebase/app";
import "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";
import "firebase/storage";

const generalConfig = {
  apiKey: "AIzaSyAMhuFsddO482nDpQp-jr6tUwyw-mjG6Us",
  authDomain: "abacus-company-project.firebaseapp.com",
  databaseURL: "https://abacus-company-project.firebaseio.com",
  projectId: "abacus-company-project",
  storageBucket: "abacus-company-project.appspot.com",
  messagingSenderId: "799769146157",
  appId: "1:799769146157:web:d497b21a3e793a5c"
};

const releaseConfig = {
  apiKey: "AIzaSyAMhuFsddO482nDpQp-jr6tUwyw-mjG6Us",
  authDomain: "abacus-company-project.firebaseapp.com",
  databaseURL: "abacus-company-project.firebaseio.com",
  projectId: "abacus-company-project",
  storageBucket: "abacus-company-project.appspot.com",
  messagingSenderId: "799769146157"
};

firebase.initializeApp(process.env.NODE_ENV == "production" ? releaseConfig : generalConfig);

/*
  setLogLevel param:
- debug for the most verbose logging level, primarily for debugging.
- error to log errors only.
- silent to turn off logging.
*/
if (process.env.NODE_ENV == "production") {
  firebase.firestore.setLogLevel("error");
} else {
  firebase.firestore.setLogLevel("error");
}

export const storage = firebase.storage();
export const db = firebase.firestore();
export const realtimedb = firebase.database();
